module.exports = __webpack_public_path__ + "static/media/select-messages.ecf89a5b.svg";